export default {
  DpScoreProgressBar: {
    correct: '{{correct}}% Correct',
    partial: '{{partial}}% Partial',
    incorrect: '{{incorrect}}% Incorrect'
  }
};